/** Inline loading spinner (uses global `.fc2-spinner` in styles.css). */
export function Fc2Spinner({
  size = 24,
  label = "Loading",
  className = "",
}: {
  size?: number;
  label?: string;
  className?: string;
}) {
  const border = Math.max(2, Math.round(size / 12));
  return (
    <div
      role="status"
      aria-label={label}
      className={`fc2-spinner ${className}`.trim()}
      style={{
        width: size,
        height: size,
        borderWidth: border,
      }}
    />
  );
}
